import { render, staticRenderFns } from "./statistics-recruitment-languages.vue?vue&type=template&id=927cf93c"
import script from "./statistics-recruitment-languages.vue?vue&type=script&lang=js"
export * from "./statistics-recruitment-languages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports